import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button';
import "./basic-information.scss";
import PatientAction from "./patientActionButtons";
import AccountCircle from '@mui/icons-material/AccountCircle';
import Man2Icon from '@mui/icons-material/Man2';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import StayPrimaryPortraitIcon from '@mui/icons-material/StayPrimaryPortrait';
import ContactMailIcon from '@mui/icons-material/ContactMail';
import StreetviewIcon from '@mui/icons-material/Streetview';
import MapIcon from '@mui/icons-material/Map';
import { useLocation, useNavigate } from 'react-router-dom';
import convert from "../../Helper/helper";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { saveAndCreateOpd } from "./basicInfoContainerService";
import { errorToast, successToast } from "../toastmessage/toastmessage";
import { handleValidation } from "./basicInformation/basicInformationValidation";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const initialState = {
    name: "",
    age: "",
    gender: "",
    mobile: "",
    regDate: convert(new Date()),
    emrNumber: "",
    alternateMobile: "",
    email: "",
    address: "",
    street: "",
    city: "",

}
const BasicInformation = (props) => {
    let location = useLocation();
    const navigate = useNavigate();
    const [errors, setError] = useState({});
    const [isValidEmail, setIsValidEmail] = useState(true);

    const { submitBasicInfo } = props
    const [basicInfoInputFields, setBasicInfoInputFields] = React.useState(initialState);
    const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))

    useEffect(() => {
        if (Object.keys(location?.state?.rowData).length > 0) {
            setBasicInfoInputFields({
                ...location?.state?.rowData,
                regDate: convert(location?.state?.rowData?.regDate),
                gender: location?.state?.rowData?.gender
            })

        }
    }, [location?.state?.rowData])



    const handleBasicInfoInputChange = (event) => {
        const { name, value } = event.target;
        setBasicInfoInputFields((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });
    }

    const handleSubmit = async (event, basicInfoInputFields, uniqueID) => {
        let isValid = await handleValidation(basicInfoInputFields)
        if (isValid?.formIsValid) {
            if (!uniqueID) {
                let finalResult = { ...basicInfoInputFields, createdBy: getUserValue?.uniqueID }
                await submitBasicInfo(event, finalResult)
            } else {
                let rowData = {
                    uniqueID: uniqueID
                }
                navigate("/patient-registration", { state: { addPatient: false, rowData: rowData } })
                return "Update Api Integration is Pending"
            }
        } else {
            let inputError = {
                ...isValid?.errors,
                formIsValid: isValid?.formIsValid,
                basicInfoError: isValid?.individualInputErrors
            }
            setError(inputError)
        }

    }

    const handleRouteOpd = async (event, basicInfoInputFields) => {
        event?.preventDefault();
        let isValid = await handleValidation(basicInfoInputFields)
        if (isValid?.formIsValid) {
            try {
                let finalResult = { ...basicInfoInputFields, createdBy: getUserValue?.uniqueID }
                let res = await saveAndCreateOpd(finalResult);
                if (res?.status === 200) {
                    let rowData = {
                        uniqueID: res?.data?.result
                    }
                    successToast(res?.data?.message);
                    navigate("/opd", { state: { rowData: rowData } })
                }

            } catch (err) {
                errorToast(err?.response?.data?.error || err?.response?.data?.message)
            }

        } else {
            let inputError = {
                ...isValid?.errors,
                formIsValid: isValid?.formIsValid,
                basicInfoError: isValid?.individualInputErrors
            }
            setError(inputError)

        }
    }


    const allowNumbersOnly = (e, type) => {
        let code = (e.which) ? e.which : e.keyCode;
        if (code > 31 && (code < 48 || code > 57)) {
            e.preventDefault();
        }
       
    }
    const handleBlur = async () => {
        const newErrors = await handleValidation(basicInfoInputFields);
        let inputError = {
            ...newErrors?.errors,
            formIsValid: newErrors?.formIsValid,
            basicInfoError: newErrors?.individualInputErrors
        }
        setError(inputError)

    };
    const handleGoBack = () => {
        navigate("/patient-registration")
    }

    const handleKeyDown = (event) => {
        validateEmail();
      };
    
      const validateEmail = () => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsValidEmail(emailPattern.test(basicInfoInputFields?.email));
      };

     
    return (
        <>
            <PatientAction isDisabled={location && location?.state?.addPatient} />
            <form className="needs-validation" novalidate>
                <div className="basic-info" >
                    <div className="mt-2 ml-4">
                        <h4>Basic Information</h4>
                        <div className="back-btn"
                            onClick={handleGoBack}
                        >
                            <ArrowBackIcon className="arrow-color" />
                            <span
                                style={{ cursor: "pointer" }}
                                className="anchr-link header-text mt-3 mb-3"
                            >
                                {"Back"}
                            </span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="validationCustom03" className="control-label col-sm">Name*</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><AccountCircle /></div>
                                    </div>
                                    <input type="text"
                                        onBlur={handleBlur}
                                        className={
                                            errors?.basicInfoError?.name ? "form-control is-invalid" :
                                                "form-control"
                                        }
                                        id="validationTooltipname"
                                        required
                                        placeholder="Name" name="name" value={(basicInfoInputFields?.name?.toUpperCase())}
                                        onChange={handleBasicInfoInputChange}
                                        aria-describedby="validationTooltipUsernamePrepend"
                                    />
                                    <div class="invalid-feedback">
                                        Please provide a valid Name.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Reg Date*</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><CalendarMonthIcon /></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="date"
                                        className={
                                            errors?.basicInfoError?.regDate ? "form-control is-invalid"
                                                : "form-control"}
                                        placeholder="Reg Date"
                                        name='regDate'
                                        value={basicInfoInputFields?.regDate}
                                        required
                                        onChange={handleBasicInfoInputChange}
                                       
                                    />
                                    <div class="invalid-feedback">
                                        Please provide a valid date.
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Age*</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><AccountCircle /></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        required
                                        className={errors?.age ?
                                            "form-control is-invalid" : "form-control"}
                                        id="lname" placeholder="Age"
                                        name="age"
                                        value={basicInfoInputFields?.age}
                                        onChange={handleBasicInfoInputChange}
                                        maxlength="3"
                                        onKeyDown={(e) => allowNumbersOnly(e, "age")}
                                    />
                                    <div class="invalid-feedback">
                                        {errors?.age}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Gender*</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><Man2Icon /></div>
                                    </div>
                                    <select
                                        onBlur={handleBlur}
                                        className={errors?.basicInfoError?.gender ? "form-control is-invalid" : "form-control"}
                                        selected={basicInfoInputFields?.gender}
                                        value={basicInfoInputFields?.gender}
                                        onChange={handleBasicInfoInputChange}
                                        required
                                        name="gender"
                                    >
                                        <option></option>
                                        <option value={1}>Male</option>
                                        <option value={2}>Female</option>
                                        <option value={3}>others</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        Please provide a valid gender.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Mobile Number*</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><StayPrimaryPortraitIcon /></div>
                                    </div>
                                    <input
                                        onBlur={handleBlur}
                                        type="text"
                                        className={errors?.basicInfoError?.mobile ? "form-control is-invalid" : "form-control"}
                                        id="lname"
                                        placeholder="Mobile Number"
                                        name="mobile"
                                        value={basicInfoInputFields?.mobile}
                                        onChange={handleBasicInfoInputChange}
                                        required
                                        maxlength="10"
                                        onKeyDown={(e) => allowNumbersOnly(e, "mobile")}
                                    />
                                    <div class="invalid-feedback">
                                        {errors?.mobile}.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Alternate Contact Number</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><StayPrimaryPortraitIcon /></div>
                                    </div>
                                    <input
                                        maxlength="10"
                                        type="text" className="form-control"
                                        onKeyDown={(e) => allowNumbersOnly(e, "alternate")}
                                        id="lname" placeholder="Alternate Contact Number" name="alternateMobile" value={basicInfoInputFields?.alternateMobile} onChange={handleBasicInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="fname" className="control-label col-sm">Email</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><AlternateEmailIcon /></div>
                                    </div>
                                    <input
                                        type="email" 
                                        // className="form-control" 
                                        className={!isValidEmail ?
                                            "form-control is-invalid" : "form-control"}
                                        id="email" 
                                        placeholder="Email" 
                                        name="email" 
                                        value={basicInfoInputFields?.email} 
                                        onChange={handleBasicInfoInputChange}
                                        onKeyDown={(e) => handleKeyDown(e)}
                                        onBlur={(e) => handleKeyDown(e)}
                                    />
                                    <div className="invalid-feedback">
                                    {!isValidEmail && <p style={{ color: 'red' }}>Invalid email address</p>}.
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Address</label>
                            <div class="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><ContactMailIcon /></div>
                                    </div>
                                    <input
                                        type="text" className="form-control" id="lname" placeholder="Address" name="address" value={basicInfoInputFields?.address} onChange={handleBasicInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Street</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><StreetviewIcon /></div>
                                    </div>
                                    <input
                                        type="text" className="form-control" id="lname" placeholder="Street" name="street" value={basicInfoInputFields?.street} onChange={handleBasicInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">city</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><StreetviewIcon /></div>
                                    </div>
                                    <input
                                        type="text" className="form-control" id="lname" placeholder="City" name="city" value={basicInfoInputFields?.city} onChange={handleBasicInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">State</label>
                            <div className="col-auto">
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text"><MapIcon /></div>
                                    </div>
                                    <input
                                        type="text" className="form-control" id="lname" placeholder="State" name="state" value={basicInfoInputFields?.state} onChange={handleBasicInfoInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2" onClick={(event) => handleSubmit(event, basicInfoInputFields, location?.state?.rowData?.uniqueID)}>
                        {location?.state?.rowData?.uniqueID ? "Update Patient" : "Add Patient"}</Button>
                    <Button variant="outlined" onClick={(event) => handleRouteOpd(event, basicInfoInputFields)}>Save & Create OPD</Button>
                </div>
            </form>
        </>
    );
};

export default BasicInformation; 

  